// src/api/dialer.js
import { apiClient } from './auth'

export function markCallAsProcessing(callId) {
  return apiClient.post(`/neue/admin/calls/analyze-call`, { callId: callId })
}

export function getGaps(userId, date, gapMinutes = 5) {
  return apiClient.get('/neue/admin/calls/gaps', {
    params: { userId, date, gapMinutes }
  })
}

export function getAnalyzedCalls() {
  return apiClient.get('/neue/admin/calls/analyzed')
}

export function submitCallReview(callId, answer) {
  return apiClient.post('/neue/admin/calls/analyzed/submit', {
    callId,
    answer
  })
}

export function completeQuizQuestion(questionId) {
  return apiClient.post(`/neue/admin/calls/quiz/${questionId}/complete`, {})
}

export function logTelnyxDebug(debugData) {
  return apiClient.post('/neue/admin/telnyx-debug', debugData)
}

export function logCallDebug(callNumber, infoDump) {
  return apiClient.post('/neue/admin/call-debug', {
    call_number: callNumber,
    info_dump: typeof infoDump === 'object' ? JSON.stringify(infoDump) : String(infoDump)
  })
}
